import * as config from "./env";
import type { ConfigContract, AppEnv } from "./types";

export function loadAppConfig(appEnv: AppEnv | "local"): ConfigContract {
  const appConfig = config[appEnv] ?? config.development;
  return appConfig;
}
